<template>
	<v-form ref="formDadosDaVaga" fast-fail :disabled="formDesabilitado || loading" @submit.prevent="salvaDadosVaga">
		<v-row>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Ocupação</div>
				<v-combobox v-model="form.ocupacao" :items="listaCBO" item-title="descricao" item-value="id" :rules="validarDadosVagas.ocupacao" @blur="form.cbo = form.ocupacao" />
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6">CBO</div>
				<v-combobox v-model="form.cbo" :items="listaCBO" item-title="codigo" item-value="id" @blur="form.ocupacao = form.cbo" />
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Número de Vagas</div>
				<v-text-field v-model="form.numeroVagas" type="number" :rules="validarDadosVagas.numeroVagas" />
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Salário Mensal R$</div>
				<v-text-field ref="inputRef" v-model="formattedValue" :rules="validarDadosVagas.salarioMensal" />
			</v-col>
			<v-col cols="12" md="12">
				<div class="mb-2 mr-6"><span class="required">* </span>Descrição das Atividades</div>
				<v-textarea v-model="form.descricaoAtividades" :rules="validarDadosVagas.descricaoAtividades" :counter="300" />
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-4 mr-6"><span class="required">* </span>O endereço do local do trabalho é o mesmo da empresa?</div>
				<v-radio-group inline v-model="form.enderecoTrabalhoIgual" :rules="validarDadosVagas.enderecoTrabalhoIgual">
					<v-radio v-for="item in listaLocalDeTrabalho" :key="item.value" :label="item.label" :value="item.value" />
				</v-radio-group>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Horário de Trabalho</div>
				<v-text-field v-model="form.horarioTrabalho" :rules="validarDadosVagas.horarioTrabalho" />
			</v-col>
		</v-row>
		<v-row v-if="form.enderecoTrabalhoIgual === 'N'">
			<v-col cols="12" md="3">
				<div class="mb-2 mr-6"><span class="required">* </span>CEP</div>
				<v-mask-input v-model="form.cep" mask="##.###-###" :rules="validarDadosVagas.cep"  @blur="buscaCep"/>
			</v-col>
			<v-col cols="12" md="3">
				<div class="mb-2 mr-6"><span class="required">* </span>UF</div>
				<v-combobox v-model="form.uf" :items="listaUFs" item-title="nomeCompleto" item-value="siglaUF" :disabled="formDesabilitado || bloqueiaCampos.uf" :rules="validarDadosVagas.uf" />
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Município</div>
				<v-combobox v-model="form.cidade" :items="listaCidades" item-title="nomeCompleto" item-value="codMunicipioRfb" :rules="validarDadosVagas.cidade" :loading="loadingCidade" :disabled="formDesabilitado || loadingCidade || bloqueiaCampos.cidade || !listaCidades.length"/>
			</v-col>
			<v-col cols="12" md="3">
				<div class="mb-2 mr-6"><span class="required">* </span>Tipo Logradouro</div>
				<v-combobox v-model="form.tipoLogradouro" :items="listaTipoLogradouro" item-title="descricao" item-value="id" :rules="validarDadosVagas.tipoLogradouro" :disabled="formDesabilitado || bloqueiaCampos.tipoLogradouro"/>
			</v-col>
			<v-col cols="12" md="4">
				<div class="mb-2 mr-6"><span class="required">* </span>Endereço</div>
				<v-text-field v-model="form.logradouro" :rules="validarDadosVagas.logradouro" :disabled="formDesabilitado || bloqueiaCampos.logradouro"/>
			</v-col>
			<v-col cols="12" md="2">
				<div class="mb-2 mr-6"><span class="required">* </span>Número</div>
				<v-text-field v-model="form.numero" :rules="validarDadosVagas.numero" :disabled="formDesabilitado || bloqueiaCampos.numero"/>
			</v-col>
			<v-col cols="12" md="3">
				<div class="mb-2 mr-6"><span class="required">* </span>Bairro</div>
				<v-text-field v-model="form.bairro" :rules="validarDadosVagas.bairro" :disabled="formDesabilitado || bloqueiaCampos.bairro"/>
			</v-col>
			<v-col cols="12" md="12">
				<div class="mb-2 mr-6">Referência de Acesso</div>
				<v-textarea v-model="form.referenciaAcesso" :rules="validarDadosVagas.referenciaAcesso"/>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="12">
				<div class="mb-2 mr-6">Benefícios</div>
				<v-row>
					<v-col
						v-for="beneficio in listaBeneficios"
						:key="beneficio.id"
						cols="6"
						md="4"
						>
						<v-checkbox v-model="form.beneficios" color="primary" :label="beneficio.descricao" density="compact" :value="beneficio" />
						<div v-if="beneficio.descricao === 'Insalubridade' && form.beneficios.includes(beneficio)" class="pl-2">
							<div class="mb-2"><span class="required">* </span>Qual o índice?</div>
							<v-text-field v-model="beneficio.complemento" density="compact" type="number" :rules="validarDadosVagas.insalubridade" append-icon="mdi-percent"/>
						</div>
						<div v-if="beneficio.descricao === 'Periculosidade' && form.beneficios.includes(beneficio)" class="pl-2">
							<div class="mb-2"><span class="required">* </span>Qual o índice?</div>
							<v-text-field v-model="beneficio.complemento" density="compact" type="number" :rules="validarDadosVagas.periculosidade" append-icon="mdi-percent"/>
						</div>
						<div v-if="beneficio.descricao === 'Outros' && form.beneficios.includes(beneficio)" class="pl-2">
							<div class="mb-2"><span class="required">* </span>Especifique</div>
							<v-text-field v-model="beneficio.complemento" density="compact" :rules="validarDadosVagas.outros"/>
						</div>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="6">
				<div class="mb-4 mr-6"><span class="required">* </span>A vaga é exclusiva para PCD?</div>
				<v-radio-group inline v-model="form.pcd" :rules="validarDadosVagas.pcd">
					<v-radio v-for="item in listaExclusivoPCD" :key="item.value" :label="item.label" :value="item.value" />
				</v-radio-group>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-4 mr-6"><span class="required">* </span>Tipo de Contratação</div>
				<v-radio-group inline v-model="form.tipoContratacao" :rules="validarDadosVagas.tipoContratacao">
					<v-radio v-for="item in listaTipoContratacao" :key="item.value" :label="item.label" :value="item.value" />
				</v-radio-group>
			</v-col>
		</v-row>
		<v-row v-if="form.tipoContratacao === 'APRENDIZAGEM'">
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Nome da Instituição que realizará o curso de Aprendizagem</div>
				<v-text-field v-model="form.instituicao" :rules="validarDadosVagas.instituicao" />
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Nome do Curso</div>
				<v-text-field v-model="form.nomeCurso" :rules="validarDadosVagas.nomeCurso" />
			</v-col>
			<v-col cols="12" md="4">
				<div class="mb-2 mr-6"><span class="required">* </span>Data de início do Curso</div>
				<v-text-field v-model="form.dataInicioCurso" :rules="validarDadosVagas.dataInicioCurso" readonly append-inner-icon="mdi-calendar-range">
					<v-dialog v-model="mostraDataInicioCurso" activator="parent" width="auto">
						<v-date-picker v-model="dataInicioCurso" elevation="24" />
					</v-dialog>
				</v-text-field>
			</v-col>
			<v-col cols="12" md="4">
				<div class="mb-2 mr-6"><span class="required">* </span>Carga horária teórica semanal</div>
				<v-text-field v-model="form.cargaHorariaTeoricaSemanal" type="number" :rules="validarDadosVagas.cargaHorariaTeoricaSemanal" />
			</v-col>
			<v-col cols="12" md="4">
				<div class="mb-2 mr-6"><span class="required">* </span>Carga horária prática semanal</div>
				<v-text-field v-model="form.cargaHorariaPraticaSemanal" type="number" :rules="validarDadosVagas.cargaHorariaPraticaSemanal" />
			</v-col>
		</v-row>
		<v-row v-if="form.tipoContratacao === 'TEMPORARIA'">
			<v-col cols="12" md="12">
				<div class="mb-2 mr-6"><span class="required">* </span>Período de contratação em dias</div>
				<v-text-field v-model="form.periodoContratacao" type="number" :rules="validarDadosVagas.periodoContratacao" />
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Motivo da Contratação</div>
				<v-row no-gutters>
					<v-col
						v-for="motivo in listaMotivoContratacao"
						:key="motivo.id"
						class="pa-0 ma-0"
						cols="6"
						>
						<v-checkbox v-model="form.motivosContratacao" :color="corTexto" :label="motivo.descricao" density="compact" :value="motivo" />
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Escolha a Agência FGTAS/Sine do local da vaga</div>
				<v-combobox v-model="form.agencia" :items="listaAgencias" item-title="nome" item-value="id" :rules="validarDadosVagas.agencia"/>
			</v-col>
		</v-row>
		<v-row v-if="!escondeBotoes">
			<v-col cols="6" align="start">
				<v-btn :color="corTexto" variant="outlined" :loading="loading" @click="voltarPasso">
					VOLTAR
				</v-btn>
			</v-col>
			<v-col cols="6" align="end">
				<v-btn color="primary" type="submit" :loading="loading" :disabled="desabilitaAvancar">
					{{ modoSolicitacao ? "SALVAR" : "AVANÇAR" }}
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>
<script setup>
import { ref, watch, computed, onMounted } from 'vue';
import { ConfirmacaoAlert } from "@/utils/AlertUtils.js";
import { vagasEnum } from '@/utils/VagaUtils';
import { useRoute } from 'vue-router'
import { cadastrarVaga, editarVaga } from '@/services/VagaService';
import { listarBeneficios, listarCBO, listarMotivoContratacao, listarMunicipios, listarTipoLogradouro, listarUfs } from '@/services/ConsultaEntidadeService';
import { buscarAgencias } from '@/services/AgenciaService';
import { buscarCep } from '@/services/EnderecosService';
import { validarDadosVagas } from '@/utils/ValidacoesUtils';
import { format } from "date-fns";
import { useStore } from 'vuex';
import { ErroAlert } from "@/utils/AlertUtils.js";
import { vuetify } from '@/plugins/vuetify'
import { useCurrencyInput } from 'vue-currency-input'

const store = useStore()
const route = useRoute();
const emit = defineEmits(["passoAnterior", "proximoPasso"]);
const props = defineProps({
	dadosVagaForm: Object,
	dataVaga: Object,
	formDesabilitado: Boolean,
	escondeBotoes: Boolean,
	modoSolicitacao: Boolean,
});

const { inputRef, setValue, formattedValue, numberValue } = useCurrencyInput({
	currency: "BRL",
	currencyDisplay: "hidden",
	valueRange: {
		min: 0,
		max: 999999.99
	},
	hideCurrencySymbolOnFocus: false,
	hideGroupingSeparatorOnFocus: false,
	hideNegligibleDecimalDigitsOnFocus: false,
	autoDecimalDigits: true,
	useGrouping: true,
	accountingSign: false,
});

const listaLocalDeTrabalho = [
	{ label: "Sim", value: "S" },
	{ label: "Não", value: "N" },
];

const listaExclusivoPCD = [
	{ label: "Sim", value: "S" },
	{ label: "Não", value: "N" },
];

const listaTipoContratacao = [
	{ label: "Aprendizagem", value: "APRENDIZAGEM" },
	{ label: "Temporária", value: "TEMPORARIA" },
	{ label: "Permanente", value: "PERMANENTE" },
	{ label: "Estágio", value: "ESTAGIO" },
];

const listaUFs = ref([]);
const listaCidades = ref([]);
const listaTipoLogradouro = ref([]);
const listaBeneficios = ref([]);
const listaMotivoContratacao = ref([]);
const listaAgencias = ref([]);
const listaCBO = ref([]);
const mostraDataInicioCurso = ref(false);
const loading = ref(false);
const loadingCidade = ref(false);
const editando = ref(false);
const formDadosDaVaga = ref();
const form = ref({
	id: editando ? Number(route.params?.id) : undefined,
	ocupacao: undefined,
	cbo: undefined,
	numeroVagas: undefined,
	salarioMensal: undefined,
	descricaoAtividades: undefined,
	logradouro: undefined,
	numero: undefined,
	bairro: undefined,
	cep: undefined,
	uf: undefined,
	cidade: undefined,
	tipoLogradouro: undefined,
	referenciaAcesso: undefined,
	enderecoTrabalhoIgual: undefined,
	horarioTrabalho: undefined,
	pcd: undefined,
	periodoContratacao: undefined,
	tipoContratacao: undefined,
	instituicao: undefined,
	nomeCurso: undefined,
	dataInicioCurso: undefined,
	cargaHorariaTeoricaSemanal: undefined,
	cargaHorariaPraticaSemanal: undefined,
	beneficios: [],
	motivosContratacao: [],
	agencia: undefined,
})
const bloqueiaCampos = ref({
	logradouro: false,
	numero: false,
	bairro: false,
	tipoLogradouro: false,
	uf: false,
	cidade: false,
});
const dataInicioCurso = ref();

async function salvaDadosVaga() {
	if (props.formDesabilitado) {
		emit("proximoPasso");
		return;
	}
	await formDadosDaVaga.value.validate();
	if (!formDadosDaVaga.value.isValid) {
		return;
	}
	const beneficiosMapped = form.value.beneficios.map((beneficio) => {
		return {
			id: beneficio.idBeneficio,
			tipoBeneficio: beneficio,
			complemento: beneficio.complemento || undefined,
		}
	})
	const motivosContratacaoMapped = form.value.motivosContratacao.map((motivo) => {
		return {
			id: motivo.idMotivo,
			motivoContratacao: motivo,
		}
	})
	const bodyRequest = ref({
		id: editando.value ? Number(form.value.id) : undefined,
		stepCadastroVaga: vagasEnum[1],
		ocupacao: typeof form.value.ocupacao === "object" ? form.value.ocupacao.descricao : form.value.ocupacao,
		cbo: typeof form.value.cbo === "object" ? form.value.cbo.codigo : form.value.cbo,
		numeroVagas: form.value.numeroVagas,
		salarioMensal: numberValue.value,
		descricaoAtividades: form.value.descricaoAtividades,
		enderecoTrabalhoIgual: form.value.enderecoTrabalhoIgual,
		enderecoLocalTrabalho: form.value.enderecoTrabalhoIgual === 'N'
			? {
				id: null,
				logradouro: form.value.logradouro,
				numero: form.value.numero,
				bairro: form.value.bairro,
				cep: form.value.cep,
				municipio: form.value.cidade,
				tipoLogradouro: form.value.tipoLogradouro,
				referenciaAcesso: form.value.referenciaAcesso,
			}
			: undefined,
		horarioTrabalho: form.value.horarioTrabalho,
		pcd: form.value.pcd,
		tipoContratacao: form.value.tipoContratacao,
		curso: form.value.tipoContratacao === "APRENDIZAGEM"
			? {
				instituicao: form.value.instituicao,
				nomeCurso: form.value.nomeCurso,
				dataInicioCurso: form.value.dataInicioCurso,
				cargaHorariaTeoricaSemanal: form.value.cargaHorariaTeoricaSemanal,
				cargaHorariaPraticaSemanal: form.value.cargaHorariaPraticaSemanal,
			}
			: undefined,
		periodoContratacao: form.value.tipoContratacao === "TEMPORARIA" ? form.value.periodoContratacao : undefined,
		beneficios: beneficiosMapped,
		motivosContratacao: motivosContratacaoMapped,
		agencia: form.value.agencia,
	});
	if (!editando.value) {
		loading.value = true;
		await cadastrarVaga({
				...props.dataVaga,
				...bodyRequest.value,
			})
			.then(({ data }) => {
				emit("proximoPasso");
			})
			.catch((error) => {
				ErroAlert({ mensagem: "Ocorreu um erro ao salvar dados da vaga. Tente novamente mais tarde!", error });
			})
			.finally(() => loading.value = false);
	}
	else {
		loading.value = true;
		await editarVaga(bodyRequest.value.id || 0,
			{
				...props.dataVaga,
				...bodyRequest.value,
			})
			.then(({ data }) => {
				emit("proximoPasso");
			})
			.catch((error) => {
				ErroAlert({ mensagem: "Ocorreu um erro ao editar dados da vaga. Tente novamente mais tarde!", error });
			})
			.finally(() => loading.value = false);
	}
}

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
})

async function buscaCep() {
	if (validarDadosVagas.cep[1](form.value.cep) === true) {
		loading.value = true;
		await buscarCep(form.value.cep)
			.then(({ data }) => {
				form.value.uf = listaUFs.value.find((uf) => uf.sigla === data.municipio.uf.siglaUf);
				bloqueiaCampos.value.uf = !!form.value.uf;

				form.value.cidade = data.municipio;
				bloqueiaCampos.value.cidade = !!form.value.cidade;

				form.value.tipoLogradouro = data.tipoLogradouro.codigo ? data.tipoLogradouro : undefined;
				bloqueiaCampos.value.tipoLogradouro = !!form.value.tipoLogradouro;

				form.value.logradouro = data.logradouro;
				bloqueiaCampos.value.logradouro = !!form.value.logradouro;

				form.value.bairro = data.bairro;
				bloqueiaCampos.value.bairro = !!form.value.bairro;
			})
			.catch((error) => {
				ErroAlert({ mensagem: error.response.data.mensagem, error });
				form.value.uf = undefined;
				form.value.cidade = undefined;
				form.value.numero = undefined;
				form.value.logradouro = undefined;
				form.value.tipoLogradouro = undefined;
				form.value.bairro = undefined;
				bloqueiaCampos.value.uf = false;
				bloqueiaCampos.value.cidade = false;
				bloqueiaCampos.value.tipoLogradouro = false;
				bloqueiaCampos.value.logradouro = false;
				bloqueiaCampos.value.bairro = false;
			})
			.finally(() => loading.value = false);
	}
}

const desabilitaAvancar = computed(() => {
	const ignorarCampos = ref(["id", "cbo", "beneficios", "referenciaAcesso"]);
	const beneficioValido = ref([])
	if (form.value.enderecoTrabalhoIgual === "S") {
		ignorarCampos.value.push("logradouro", "numero", "bairro", "cep", "uf", "cidade", "tipoLogradouro");
	}
	if (form.value.tipoContratacao !== "APRENDIZAGEM") {
		ignorarCampos.value.push("instituicao", "nomeCurso", "dataInicioCurso", "cargaHorariaTeoricaSemanal", "cargaHorariaPraticaSemanal");
	}
	if (form.value.tipoContratacao !== "TEMPORARIA") {
		ignorarCampos.value.push("periodoContratacao");
	}
	if (form.value.beneficios.length) {
		if (form.value.beneficios.find(b => b.descricao === "Outros")) {
			beneficioValido.value.push(!!form.value.beneficios.find(b => b.descricao === "Outros").complemento);
		};
		if (form.value.beneficios.find(b => b.descricao === "Periculosidade")) {
			beneficioValido.value.push(!!form.value.beneficios.find(b => b.descricao === "Periculosidade").complemento);
		};
		if (form.value.beneficios.find(b => b.descricao === "Insalubridade")) {
			beneficioValido.value.push(!!form.value.beneficios.find(b => b.descricao === "Insalubridade").complemento);
		};
	}
	const formValido = Object.keys(form.value).every(key => {
		if (ignorarCampos.value.includes(key)){
			return true;
		}
		if (key === "salarioMensal") {
			return numberValue.value && numberValue.value !== "";
		}
		if (key === "motivosContratacao") {
			return form.value[key].length > 0
		}
		return !!form.value[key] && form.value[key] !== "";
	});
	let contemErro = false;
	if (formDadosDaVaga.value) {
		contemErro = !!formDadosDaVaga.value.errors.length
	}
	return !formValido || contemErro || !beneficioValido.value.every((b) => !!b);
});

async function voltarPasso() {
	if (props.formDesabilitado) {
		emit("passoAnterior");
		return;
	}
	ConfirmacaoAlert({
		title: "Deseja voltar?",
		message: "Ao voltar você pode perder as informações não salvas nesse formulário",
		onConfirm: () => emit("passoAnterior"),
		confirmText: "Voltar",
		cancelText: "Cancelar",
		showCancelButton: true,
	});
}

async function buscaUF() {
	if (store.getters["entidades/getListaUFs"].length) {
		listaUFs.value = store.getters["entidades/getListaUFs"];
		return;
	}
	await listarUfs()
		.then(({ data }) => {
			listaUFs.value = data;
			store.commit("entidades/setListaUFs", data);
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscaCidades() {
	loadingCidade.value = true;
	await listarMunicipios(form.value.uf.siglaUf)
		.then(({ data }) => {
			listaCidades.value = data;
			if (form.value.cidade && form.value.cidade.codMunicipioRfb) {
				form.value.cidade = listaCidades.value.find((cidade) => form.value.cidade.codMunicipioRfb === cidade.codMunicipioRfb);
			}
			else {
				form.value.cidade = undefined;
			}
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		})
		.finally(() => loadingCidade.value = false);
}

async function buscaTipoLogradouro() {
	if (store.getters["entidades/getListaTipoLogradouro"].length) {
		listaTipoLogradouro.value = store.getters["entidades/getListaTipoLogradouro"];
		return;
	}
	await listarTipoLogradouro()
		.then(({ data }) => {
			listaTipoLogradouro.value = data;
			store.commit("entidades/setListaTipoLogradouro", data);
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscaBeneficios() {
	await listarBeneficios()
		.then(({ data }) => {
			const beneficios = data.sort((a, b) => a.id - b.id);
			listaBeneficios.value = beneficios.map((beneficio) => {
				const selecionado = form.value.beneficios.find((b) => b.id === beneficio.id);
				return selecionado || beneficio;
			})
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscaMotivoContratacao() {
	await listarMotivoContratacao()
		.then(({ data }) => {
			const motivos = data;
			listaMotivoContratacao.value = motivos.map((motivo) => {
				const selecionado = form.value.motivosContratacao.find((m) => m.id === motivo.id);
				return selecionado || motivo;
			});
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscarCBO() {
	if (store.getters["entidades/getListaCBO"].length) {
		listaCBO.value = store.getters["entidades/getListaCBO"];
		if (form.value.ocupacao) {
			form.value.ocupacao = listaCBO.value.find((cbo) => cbo.descricao === form.value.ocupacao)
		}
		if (form.value.cbo) {
			form.value.cbo = listaCBO.value.find((cbo) => cbo.codigo === form.value.cbo)
		}
		return;
	}
	await listarCBO()
		.then(({ data }) => {
			listaCBO.value = data.map((item) => {
				return {
					id: item.id,
					codigo: item.codigo,
					descricao: item.descricao,
					label: `${item.codigo} | ${item.descricao}`
				}
			});
			store.commit("entidades/setListaCBO", listaCBO.value)
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscaAgencias() {
	if (store.getters["entidades/getListaAgencias"].length) {
		listaAgencias.value = store.getters["entidades/getListaAgencias"];
		return;
	}
	await buscarAgencias()
		.then(({ data }) => {
			listaAgencias.value = data;
			store.commit("entidades/setListaAgencias", data)
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

watch(() => props, () => {
	form.value = props.dadosVagaForm;
}, { deep: true, immediate: true });

watch(dataInicioCurso, () => form.value.dataInicioCurso = format(dataInicioCurso.value, "dd/MM/yyyy"));

watch(() => form.value.uf, async (newValue, oldValue) => {
	if (!newValue) {
		return;
	}
	if (newValue === oldValue) {
		return;
	}
	await buscaCidades();
});

onMounted(async () => {
	await buscaUF();
	await buscaBeneficios();
	await buscaMotivoContratacao();
	await buscaAgencias();
	await buscarCBO();
	await buscaTipoLogradouro();
	if (!isNaN(route.params?.id)) {
		editando.value = true;
	}
	setValue(form.value.salarioMensal);
});
</script>
<style lang="css" scoped>
.radio {
	display: inline-flex;
}
.required {
	color: red;
}
</style>